import { useWindowSize } from "@elit-hair/elit-tools";
import { Button, Icon } from "@elit-hair/elit-ui";
import { Link, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { TbCalendarUser } from "react-icons/tb";

import { CalendarList } from "@/pages/calendars/components/list";
import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.CALENDARS)({
    component: Calendars,
});

function MyAppointmentsLink() {
    const { t } = useTranslation();

    return (
        <div className="flex justify-end shrink-0">
            <Link to={APP_ROUTES_TO.APPOINTMENTS}>
                <Button variant="outline" size="sm" className="flex items-center gap-2">
                    <Icon icon={TbCalendarUser} />
                    <span>{t("my_appointments")}</span>
                </Button>
            </Link>
        </div>
    );
}

function Calendars() {
    const { size } = useWindowSize();
    const isDesktop = size.md;

    if (!isDesktop) {
        return (
            <div className="flex flex-col gap-4 h-full min-h-0">
                <MyAppointmentsLink />
                <CalendarList />
            </div>
        );
    }
    return (
        <div className="flex flex-col gap-4 h-full">
            <MyAppointmentsLink />
            <div className="flex gap-4 flex-1 min-h-0">
                <CalendarList />
            </div>
        </div>
    );
}
